//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            dialogVisible: false,
            formSending: false,
            form: {},
            formErrors: {},
            defaultForm: {
                id: null,
                email: ''
            }
        };
    },

    computed: {
        formMethod () {
            return this.form.id === null ? 'post' : 'put';
        },

        formUrl () {
            return 'whitelisted-emails' + (this.form.id !== null ? '/' + this.form.id : '');
        }
    },

    mounted () {
        this.form = _.clone(this.defaultForm);
    },

    methods: {
        setItem (item) {
            if (!item) {
                this.form = _.clone(this.defaultForm);
            } else {
                this.form = {
                    id: item.id,
                    email: item.email
                };
            }
        },

        handleSave () {
            axios({
                method: this.formMethod,
                url: this.formUrl,
                data: this.form
            }).then(response => {
                this.$message({
                    type: 'success',
                    message: response.data.message
                });
                this.$emit('form-saved');
                this.hide();
            }).catch(error => {
                if (error.response.status === 422) {
                    this.formErrors = error.response.data.errors;
                }
            });
        },

        show () {
            this.formErrors = {};
            this.dialogVisible = true;
        },

        hide () {
            this.dialogVisible = false;
        }
    }
};
